import world from './en/world.en';
import auth from './en/auth.en';
import editors from './en/editors.en';

export default {
  ...world,
  ...auth,
  ...editors,
};
